// A session the server will never accept again: the token was signed with an
// earlier JWT_SECRET, expired, or its user or session is gone. The server says
// so with 401 + code `session_invalid` (ApiError.sessionInvalid); the client
// signs out quietly — no error toast, no message on the login page — and the
// route guards take the user to /login, or leave a public app open as anonymous.

export const isSessionInvalidError = (error) => (
  error?.response?.status === 401
  && error.response.data?.error?.code === 'session_invalid'
);

let onSessionEnded = null;

// UserContext registers how to clear its state. Returns the unregister function.
export const setSessionInvalidHandler = (handler) => {
  onSessionEnded = handler;
  return () => {
    if (onSessionEnded === handler) onSessionEnded = null;
  };
};

// Why the server ended it, when it says (error.reason): 'migrated' means the
// account moved to Microsoft sign-in, so the user signs in there.
export const sessionInvalidReason = (error) => error?.response?.data?.error?.reason || null;

// Drops the dead token and signs out once, however many requests in flight
// fail with it: only the first finds the token still stored.
export const endInvalidSession = (storage = localStorage, reason = null) => {
  if (!storage.getItem('token')) return;
  storage.removeItem('token');
  onSessionEnded?.(reason);
};
